export function DelShareIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M12.232 7a4 4 0 11.731 2.306l-2.035 1.162c.196.472.304.99.304 1.532 0 .543-.108 1.06-.304 1.532l.86.491c.26-.453.583-.879.97-1.266a6 6 0 11-1.663 3.174l-1.384-.791a4 4 0 110-6.28l2.542-1.452a4.043 4.043 0 01-.02-.408zm4-2a2 2 0 100 4 2 2 0 000-4zm-9 5a2 2 0 100 4 2 2 0 000-4zm6.78 5.997a1 1 0 100 2h5.983a1 1 0 100-2h-5.983z"
      ></path>
    </svg>
  );
}
